import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { isLoggedIn } from '../../utils/auth';
import styles from './Navbar.module.css';

export default function Navbar() {
  const location = useLocation();
  const [loggedIn, setLoggedIn] = useState(isLoggedIn());

  // 监听登录态变化（登录/登出/过期），保持导航实时更新
  useEffect(() => {
    const sync = () => setLoggedIn(isLoggedIn());
    window.addEventListener('ranxinview:auth-change', sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener('ranxinview:auth-change', sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  return (
    <nav className={styles.navbar}>
      <div className={styles.inner}>
        <Link to="/" className={styles.logo}>
          <span className={styles.logoIcon}>◈</span>
          <span className={styles.logoText}>NeonGrid</span>
        </Link>

        <div className={styles.navLinks}>
          <Link
            to="/archive"
            className={`${styles.navLink} ${location.pathname.startsWith('/archive') ? styles.active : ''}`}
          >
            ARCHIVE
          </Link>
          <Link
            to="/cyberpunk"
            className={`${styles.navLink} ${location.pathname === '/cyberpunk' ? styles.active : ''}`}
          >
            GALLERY
          </Link>
          <Link
            to="/outro"
            className={`${styles.navLink} ${location.pathname === '/outro' ? styles.active : ''}`}
          >
            STATUS
          </Link>
          {loggedIn && (
            <>
              <Link
                to="/guide"
                className={`${styles.navLink} ${location.pathname === '/guide' ? styles.active : ''}`}
              >
                GUIDE
              </Link>
              <Link
                to="/admin"
                className={`${styles.navLink} ${location.pathname === '/admin' ? styles.active : ''}`}
              >
                ADMIN
              </Link>
            </>
          )}
        </div>

        <div className={styles.terminal}>
          <span className={styles.terminalPrompt}>❯</span>
          <span className={styles.terminalCursor} />
        </div>
      </div>
    </nav>
  );
}
